import React from 'react';
import * as Yup from 'yup';
import { Button, Dialog, DialogProps } from '@economic/taco';

import { t, Trans } from '@lingui/macro';
import { Column, Row } from '../../shared/components/Grid/Grid';
import { Form, Field } from '../../shared/components/Form';
import { FormProps } from '../types';
import internalApiClient from '../../shared/util/api/internalApiClient';
import { tLegacy } from '../../shared/components/l10n/l10n';
import { ProductDiscountGroup } from '../../../types/internal-api';

type ProductDiscountGroupFormProps = FormProps<ProductDiscountGroup>;
type ProductDiscountGroupDialogProps = Omit<DialogProps, 'children'> & ProductDiscountGroupFormProps;

const initialValues: Partial<ProductDiscountGroup> = {
    number: undefined,
    name: undefined,
};

const validationSchema = () =>
    Yup.object({
        number: Yup.number().required(),
        name: Yup.string().required(),
    });

// Todos: add proper types
export default function CreateProductDiscountGroupForm({
    initialData = initialValues,
    notifications,
    onSubmitted,
    onSubmitError,
    onCancel,
}: ProductDiscountGroupFormProps) {
    const handleSubmit = async values => {
        try {
            const response = await internalApiClient.post(`/products/discount-groups`, values);
            return Promise.resolve(response);
        } catch (error) {
            error.validation = error.response.data;
            return Promise.reject(error);
        }
    };

    return (
        <Form
            initialData={initialData}
            messages={notifications}
            onSubmit={handleSubmit}
            onSubmitted={onSubmitted}
            onSubmitError={onSubmitError}
            validationSchema={validationSchema}>
            <h1>{tLegacy`FORM_STOCKREBATEGROUP_HEADLINE`}</h1>

            <Row>
                <Column>
                    <Field.Number label={t`No.`} name="number" required />
                    <Field.Text label={t`Name`} name="name" required />
                </Column>
            </Row>

            <div className="form__buttons">
                <Button type="submit" appearance="primary">
                    <Trans>Save</Trans>
                </Button>
                {onCancel && (
                    <Button onClick={onCancel} appearance="default">
                        <Trans>Cancel</Trans>
                    </Button>
                )}
            </div>
        </Form>
    );
}

export const CreateProductDiscountGroupDialog = ({ onSubmitted: handleSubmitted, ...props }: ProductDiscountGroupDialogProps) => {
    return (
        <Dialog {...props} size="xs">
            <Dialog.Content aria-label={tLegacy`FORM_STOCKREBATEGROUP_CREATETEXT`}>
                {({ close }) => (
                    <CreateProductDiscountGroupForm
                        onCancel={close}
                        onSubmitted={productDiscountGroup => {
                            if (handleSubmitted) {
                                handleSubmitted(productDiscountGroup);
                            }

                            close();
                        }}
                    />
                )}
            </Dialog.Content>
        </Dialog>
    );
};
